import { React } from 'react';
import { TitlePanel } from '../panels/TitlePanel';
import { NavigatorPanel } from '../panels/NavigatorPanel';
import { MenuPanel } from '../panels/MenuPanel';
import { StatusPanel } from '../panels/StatusPanel';
import { DashboardPanel } from '../panels/DashboardPanel';
import { NotepadPanel } from '../panels/NotepadPanel';
import { LoginPanel } from '../panels/LoginPanel';
import { ContactsKatsia } from '../panels/Contacts_Katsia';
import { ContactsDave } from '../panels/Contacts_Dave';
import { UsersKatsia } from '../panels/Users_Katsia';

export function Dashboard(props) {
	
	/*
	State here for state shared between panels on dashboard
	Such as status in status bar.
	*/
	
  return (
    <div className={props.className}>
    	<TitlePanel username={props.username} logout={props.logout} />
    	{/*
    	Props.className is the CSS layout class: either landing or dashboard.
    	For landing, we only want the single main-panel component.
    	For Dashboard, display the navigator, menu and status panel as well as the main panel.
    	*/}
    	{ props.className === "dashboard" && <NavigatorPanel page={props.card}/> }
    	{ props.className === "dashboard" && <MenuPanel page={props.card} rbc={props.rbc}/> }
    	
    	{/* Main panel selection based on props.card setting */}
    	<div className="main-panel">
    	    { props.card === "Login" && <LoginPanel {...props} /> }
    		{ props.card === "Dashboard" && <DashboardPanel {...props} /> }
    		{ props.card === "Notepad" && <NotepadPanel {...props} /> }
    		{ props.card === "Contacts_Dave" && <ContactsDave {...props} /> }
    		{ props.card === "Contacts_Katsia" && <ContactsKatsia {...props} /> }
    		{ props.card === "Users_Katsia" && <UsersKatsia {...props} /> }
    	</div>
    	
    	{ props.className === "dashboard" && <StatusPanel formStatus={props.formStatus} /> }
    </div>
  );
}